export default "__VITE_ASSET__CaO_sNid__"